/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiRoamingHowtoUrlsGet$Params {

/**
 * Localization.
 */
  lang?: string;

/**
 * Application type. 1 - Web, 2 - Mobile.
 */
  appType?: number;
  product?: string;
}

export function apiRoamingHowtoUrlsGet(http: HttpClient, rootUrl: string, params?: ApiRoamingHowtoUrlsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiRoamingHowtoUrlsGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('appType', params.appType, {});
    rb.query('product', params.product, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiRoamingHowtoUrlsGet.PATH = '/api/Roaming/HowtoUrls';
